<template>
  <div class="IndexBox">
    <div class="ScrollBox">
      <van-nav-bar
      fixed
	  style="z-index: 9999;"
      :border="false"
      :title="$t('user.vipl')"
      left-arrow
      @click-left="$router.go(-1)"
    />

      <!-- <van-swipe :autoplay="3000" indicator-color="#888" style="height: 10rem">
        <van-swipe-item v-for="(item,index) in InitData.bannerList" :key="index">
          <img :src="item" width="100%">
        </van-swipe-item>
      </van-swipe> -->
    <div style="height: 270px;">
      <div style="background: url('./static/images/vip/vip_head_bg@2x.png');background-size: 100% 100%;height: 198px;">
        <div :style="{
    backgroundImage: `url(./static/images/vip/VIP${UserInfo.vip_level - 1}.png)`,
    backgroundSize: '98% 98%',
    height: '187px',
    width: 'calc(100% - 10px)',
    margin: '0 15px',
    top: '80px',
    position: 'absolute',
    display: 'flex'
  }">
          <div>
            
            <div style="color:rgb(254, 229, 123);padding-top: 85px; margin-left:15px;color: #594b43;">
              <div v-html="$t('vip.list.label',{number: UserInfo.number})"></div>
            </div>
            <div style="color: #594b43;padding-left: 15px;">{{$t("details[4]")}}：{{parseInt(getCurrentInfo(UserInfo.vip_level).number* parseFloat(getCurrentInfo(UserInfo.vip_level).commission))}}{{InitData.currency}}</div>
          </div>
          <div style="font-size: 14px;margin-left:80px;color: #B96233;margin-top: 30px;font-size: 18px;">
            <div  v-if="UserInfo.vip_level>1">
              <p style="font-size:16px;">{{$t("details[5]")}}</p>
              <p style="font-size: 12px;color: #594b43;">{{UserInfo.level_amount}}</p>
              <p style="font-size:16px;">{{$t("details[6]")}}</p>
              <p style="font-size: 12px;color: #594b43;">{{UserInfo.vip_end_time}}({{UserInfo.validityDay}} {{$t("details[7]")}})</p> 
            </div>
            <div style="margin-top: 5px;">
               <p style="font-size:16px;">{{$t('vip.user.value[0]')}}</p>
              <!-- <p style="margin-top: 5px;">{{$t('vip.user.value[1]')}}</p> -->
              <p style="font-size: 12px;color: #594b43;">{{UserInfo.fmt_stime+'~'+UserInfo.fmt_etime}}</p>
            </div>
           
          </div>
			  </div>
      </div>
    </div>

      <van-cell-group :border="false">
        <van-cell 
          v-for="item in InitData.UserGradeList" 
          :key="item.grade"
          :style="{
            backgroundImage: `url(./static/images/vip/VIP${item.grade - 1}.png)`,
			backgroundSize: '98% 98%',
            height: '180px', // 根据设计调整
            borderRadius: '12px',
            margin: '12px 0',
            position: 'relative',
            overflow: 'hidden'
          }">
          
          <!-- 背景图层 -->
          <div class="vip-card-bg-layer">
            <div class="vip-card-corner-mark" v-if="item.grade >1">{{ item.grade -1}} {{$t("details[3]")}}</div>
          </div>
      
          <!-- 内容浮层 -->
          <div class="vip-card-content">
            <!-- 左侧信息区 -->
            <div class="info-section">
              
              <div class="price-line">
                
                <span class="amount" style="position: absolute;bottom: 10%;left: 48%;">{{ item.amount }}{{ InitData.currency }}</span>
              </div>
              <div class="task-details">
                <p>{{$t("details[0]")}}: {{ item.commission }}</p>
                <p>{{$t("details[1]")}}: {{ item.number }}</p>
                <p>{{$t("details[2]")}}: {{ parseInt(item.number * item.commission) }}{{ InitData.currency }}</p>
              </div>
            </div>
      
            <!-- 右侧操作区 -->
            <div class="action-section">
              <div v-if="item.max_pop" class="progress">
                <van-progress 
                  :percentage="(item.num / item.max_pop) * 100" 
                  stroke-width="8"
                  color="#C5B358"
                  track-color="#37774C"/>
                <span>{{ item.num }}/{{ item.max_pop }}</span>
              </div>
              
			  <!-- 新增金额容器 -->
			    <div class="action-bottom">
			      <van-button
			        v-if="item.grade != 1 && item.state != 3"
			        class="vip-action-btn"
			        @click="submitBuy(item.amount, item.grade, item.name, item.state)">
			        {{ $t('task.index[2]') }}
			      </van-button>
				  <van-button
				    v-if="item.state == 3"
				    class="vip-action-btn renew-btn"
				    @click="submitBuy(item.amount, item.grade, item.name, item.state)">
				    {{ $t('task.index[7]') }}
				  </van-button>
			      
			    </div>
              <div v-if="item.state == 3" class="status-tip">
                {{ $t('vip.list.text[5]') }}
              </div>
            </div>
          </div>
        </van-cell>
      </van-cell-group>



    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'VIP',
  components: {

  },
  props: [],
  data() {
    return {

    }
  },
  computed: {
	  vipCardStyle() {
	      return (grade) => {
			  
	        try {
	          const imgPath = require(`@/static/images/vip/VIP${grade}.png`);
	          return {
	            backgroundImage: `url(${imgPath})`,
	            height: '180px', // 根据设计调整
	            borderRadius: '12px',
	            margin: '12px 0',
	            position: 'relative',
	            overflow: 'hidden'
	          }
	        } catch (e) {
	          console.error('VIP背景图加载失败:', e);
	          return {
	            backgroundImage: 'linear-gradient(135deg, #37774C, #2A5C3D)',
	            // 其他默认样式...
	          }
	        }
	      }
	    }

  },
  watch: {

  },
  created() {
    this.$Model.GetUserInfo();
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    getCurrentInfo(level) {
        return this.InitData.UserGradeList.find(item => item.grade === level) || null;
    },
    submitBuy(amount,grade,name,state) {
		if (state == 3) {
			this.$dialog.alert({
			  message: 'Under development'
			}).then(() => {
			  // on close
			});
		} else {
			var html = this.$t('vip.dialog[0]',{currency:this.InitData.currency,amount: amount,name: name})
			this.$Model.GetUserInfo(data=>{
			  if(data.code==1){
			    if(data.info.vip_level>grade){
			      this.$toast.fail(this.$t('vip.dialog[1]',{currname: data.info.useridentity,name: name}))
			    }else{
			      if(data.info.vip_level==grade){
			        html = this.$t('vip.dialog[2]',{currency:this.InitData.currency,amount: amount,name: name})
			      }
			      /*this.$Dialog.Confirm(html,()=>{
			        this.$Model.BuyVip({grade:grade},data=>{
			          if(data.code==1){
			            this.$Model.GetUserInfo()
			          }
			          if(data.code==2){
			            this.$router.push(`/user/recharge?amount=${Number(data.amount)}`)
			          }
			        })
			      })*/
						this.$dialog.confirm({
								 message: html,
								 confirmButtonText: this.$t('vip.index[1]'),
								 cancelButtonText: this.$t('vip.index[0]')
						}).then(()=> {
								 this.$Model.BuyVip({grade:grade},data=>{
								 console.log(data);
									if(data.code==1){
									  this.$Model.GetUserInfo()
									}
									if(data.code==2){
									  this.$router.push('/user/recharge?amount='+amount)
									}
								})
						}).catch(() => {
								
						})
			    }
			  }
			})
		}
      
    },
  }
}
</script>
<style scoped>
	
	:root {
	  --primary-color: #37774C;    /* 主色调 */
	  --secondary-color: #2A5C3D; /* 深色辅助 */
	  --accent-color: #C5B358;     /* 强调色（金色） */
	  --light-bg: #E8F5E9;         /* 浅色背景 */
	}
	/* 全局主色调定义 */
	:root {
	  --primary-color: #37774C;    /* 主色调 */
	  --secondary-color: #2A5C3D; /* 深色辅助 */
	  --accent-color: #C5B358;     /* 强调色（金色） */
	  --light-bg: #E8F5E9;         /* 浅色背景 */
	}
	
	/* VIP头部区域 */
	div[style*="backgro: url('./static/images/vip/vip_head_bg@2x.png')"] {
	  background-color: var(--primary-color) !important;
	}
	
	/* 等级卡片背景 */
	.van-cell {
	  background: linear-gradient(145deg, var(--light-bg) 60%, #FFFFFF 100%);
	  box-shadow: 0 4px 12px rgba(55, 119, 76, 0.15);
	}
	
	/* 等级名称标签 */
	div[style*="background: url('./static/images/vip/card1@2x.png')"] {
	  background: var(--primary-color) !important;
	  color: #FFFFFF !important;
	  font-weight: 600;
	}
	
	/* 金额显示 */
	p[style*="color: #BC9F64"] {
	  color: var(--primary-color) !important;
	  font-size: 18px;
	  font-weight: bold;
	}
	
	/* 描述文字 */
	p[style*="color: #3C9E83"] {
	  color: #666666 !important;
	  font-size: 14px;
	}
	
	/* 按钮样式 */
	/deep/ .van-button {
	  background: linear-gradient(
	    135deg, 
	    #C5A94B 0%,    /* 调整主色调为更明亮的金色 */
	    #D4B85E 50%,   /* 中间过渡色 */
	    #C5A94B 100%   /* 保持色调统一 */
	  ) !important;
	  border: 2px solid rgba(255, 255, 255, 0.3) !important; /* 增加边框提升质感 */
	  box-shadow: 
	    0 4px 12px rgba(197, 169, 75, 0.3), /* 调整阴影颜色匹配主色 */
	    inset 0 2px 4px rgba(255, 255, 255, 0.2) !important; /* 内阴影增加立体感 */
	  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2); /* 文字阴影增强可读性 */
	}
	
	/* 悬停状态优化 */
	/deep/ .van-button:hover {
	  background: linear-gradient(
	      135deg, 
	      #B89A3F 0%,
	      #C5A94B 50%,
	      #B89A3F 100%
	    ) !important;
	    box-shadow: 
	      0 2px
	}
	
	.van-button:active {
	  background: var(--secondary-color) !important;
	}
	
	/* 时间显示 */
	div[style*="color: #947D70"] {
	  color: #888888 !important;
	  font-size: 13px;
	}
	
	/* 进度条增强 */
	.xnum {
	  color: var(--accent-color) !important;
	  font-weight: bold;
	}
	
	/* 头部文字调整 */
	h2[style*="color: #D8875B"] {
	  color: var(--secondary-color) !important;
	  text-shadow: 1px 1px 2px rgba(255,255,255,0.3);
	}
	
	/* 新增渐变边框效果 */
	.van-cell::before {
	  content: '';
	  position: absolute;
	  top: -2px;
	  left: -2px;
	  right: -2px;
	  bottom: -2px;
	  background: linear-gradient(45deg, var(--primary-color), var(--accent-color));
	  z-index: -1;
	  border-radius: 27px;
	}
.xnum{float: right;}	
.van-cell-group{
  background: transparent;
  padding: .9375rem;
}
.van-cell{
  font-size: 16px;
 /* background: url('/static/images/vip/vip1.png') no-repeat;
  background-size:100% 100%;
  background-attachment: fixed;
  box-shadow: 0 1px 2px rgba(0,0,0,.2); */
  background: #E9FFEC;
  border-radius: 25px;
  padding: 0;
  height: 110px;
  
}


.ScrollBox{
  position:relative;
  width:100%;
  height:100%;
  overflow-x:hidden;
  overflow-y:auto;
}
.van-cell+.van-cell{
  margin-top: 12px;
  
}

.van-cell .van-cell__title{
  color: #fff;
  text-align: center;
  line-height: 1;
  overflow: hidden;
}
.van-cell .van-cell__title>p{
  margin-top: 10px;
  font-size: 14px;
}
.van-cell .van-cell__title .top{
  font-size: 24px;
  margin-bottom: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.van-cell .van-cell__title .top p{
  margin-top: 15px;
  opacity: .5;
}
.van-cell .van-cell__title .top small{
  font-size: 16px;
  color: #ff0;
}
.van-cell .van-cell__title .bottom{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  text-align: right;
}
.van-cell .van-cell__title .bottom a{
  color: #fff;
  font-size: 18px;
}
.van-cell .van-cell__title .bottom div{
  font-size: 12px;
  margin-top: 8px;
}
.van-cell .van-cell__value{
  color: #333;
  white-space: nowrap;
  padding-top: 3.125rem;
}

.van-button{width:80px;margin-top: 20px;}
.van-button--small{
  padding: 0;
}
/deep/.van-nav-bar__title{
	color: #fff;
}

/deep/ .van-button {
  background: linear-gradient(145deg, 
    #00aa00 0%, 
    #00ff7f 30%,
    #C5B358 100%) !important;
  border: none !important;
  box-shadow: 0 3px 6px rgba(55,119,76,0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
  transform: translateZ(0); /* 触发GPU加速 */
  color: #fff;
}

/* 动画关键帧 */
@keyframes buttonShine {
  0% { left: -150% }
  100% { left: % }
}

/* 流光效果优化 */
/deep/ .van-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 60%;
  height: 120%;
  background: linear-gradient(
    to right,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.25) 50%,
    rgba(255,255,255,0) 100%
  );
  transform: skewX(-25deg);
  animation: buttonShine 2s infinite;
  opacity: 0.6;
}

/* 悬停状态增强 */
/deep/ .van-button:hover {
  transform: scale(1.05) translateZ(0);
  box-shadow: 0 5px 15px rgba(55,119,76,0.3) !important;
  filter: brightness(1.1);
}

/* 禁用状态样式 */
/deep/ .van-button[disabled] {
  opacity: 0.7;
  filter: grayscale(0.8);
}


/* // VIP卡片背景层 */
.vip-card-bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  z-index: 1;
  
  /* // 渐变遮罩提升文字可读性 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      120deg,
      rgba(0, 0, 0, 0.6) 20%,
      rgba(0, 0, 0, 0.3) 80%
    );
    border-radius: inherit;
  }
}

/* // 角标设计 */
.vip-card-corner-mark {
  position: absolute;
  top: 20px;
  right: -8px;
  background: #C5B358;
  color: #2A5C3D;
  padding: 4px 16px;
  font-weight: bold;
  clip-path: polygon(0 0, 100% 0, 90% 50%, 100% 100%, 0 100%, 10% 50%);
  z-index: 2;
  padding-top: 0.625rem;
}

/* // 内容浮层 */
.vip-card-content {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  color: white;

  .info-section {
    flex: 1;
	padding-top: 10px;
    
    .price-line {
      display: flex;
      align-items: baseline;
	  
	    justify-content: flex-end; /* 水平右对齐 */
	    align-items: flex-end;     /* 垂直底部对齐 */
	    height: 40px;              /* 给容器明确高度 */
	    margin-top: -15px;         /* 向上偏移补偿高度 */
      .currency {
        font-size: 18px;
        margin-right: 4px;
      }
      .amount {
        font-size: 28px;
        font-weight: bold;
        color: #C5B358;
		padding-top: 10px;
		/* 新增间距调整 */
		    margin-right: 10px;
		    margin-bottom: 5px;
		    /* 文字阴影增强可读性 */
		    text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
      }
    }
    .task-details {
      /* margin-top: 12px; */
      p {
        margin: 6px 0;
        font-size: 12px;
      }
    }
  }

  .action-section {
    width: 120px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;

    .progress {
      width: 100%;
      text-align: center;
      span {
        display: block;
        margin-top: 4px;
        font-size: 12px;
      }
    }

    .vip-action-btn {
      background: linear-gradient(45deg, #C5B358, #EBB669);
      border: none;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      transition: transform 0.2s;
      
      &:active {
        transform: scale(0.95);
      }
    }
	
	
	
	.renew-btn {
		font-size: 12px;
		width: 150px;
	  background: linear-gradient(145deg, #37774C, #2A5C3D) !important;
	  color: #C5B358 !important;
	  border: 1px solid #C5B358 !important;
	  font-weight: bold;
	  letter-spacing: 0.5px;
	}

    .status-tip {
      font-size: 12px;
      color: #C5B358;
      text-align: center;
      padding: 8px;
      background: rgba(0,0,0,0.3);
      border-radius: 4px;
    }
  }
}



</style>



